import { CSSProperties } from "react";

export const styles: { [key: string]: CSSProperties } = {
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginTop: "-60px",
  },
  titleArea: {
    width: "86vw",
    margin: "2rem auto",
  },
  title: {
    fontSize: 30,
  },
  rowContainer: {
    width: "90vw",
    display: "flex",
    marginBottom: "1rem",
    justifyContent: "center",
  },
  button: {
    marginTop: 3,
  },
  graphBox: {
    marginTop: "2rem",
    width: "85vw",
    height: "60vh",
  },
};
